import { Tabs, TabsList, TabsTrigger } from 'components/ui/tabs'

import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'

import React from 'react'

interface PropsTabsSections {
    section: string
    indexTab: number
    tabFromPath: string
    setIndexTab: (arg0: number) => void
    tabs: string[]
}

export default function TabsSections(props: PropsTabsSections) {
    const { t } = useTranslation('header')
    const router = useRouter()

    const handleAnchor = React.useCallback(() => {
        props.setIndexTab(props.tabs.findIndex((el) => el === props.tabFromPath))
    }, [props])

    const handleChangeTab = React.useCallback(
        (val: number) => {
            router.push(`${props.tabs[val]}`)

            props.setIndexTab(val)
        },
        [props, router],
    )

    React.useEffect(() => {
        handleAnchor()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="border-b flex my-3 no-scrollbar sm:scrollbar-hide pr-2 w-full justify-between">
            {props.tabs.length > 1 ? (
                <Tabs
                    className="pl-1 w-full no-scrollbar overflow-scroll sm:scrollbar-hide flex items-start sm:pl-8"
                    value={props.indexTab.toString()}>
                    <TabsList className="flex  sm:scrollbar-hide justify-between">
                        {props.tabs.map((v, i) => (
                            <TabsTrigger
                                key={t(`${v}`)}
                                onClick={() => handleChangeTab(i)}
                                value={t(`${props.section}.${v}.title`)}
                                className={`text-${
                                    i === props.indexTab ? 'primary' : 'neutral-100'
                                } border-primary w-full uppercase text-md`}>
                                <p className={`${i === props.indexTab ? 'text-primary' : 'text-neutral-400'}`}>
                                    {t(`${props.section}.${v}.title`)}
                                </p>
                            </TabsTrigger>
                        ))}
                    </TabsList>
                </Tabs>
            ) : null}
        </div>
    )
}
